import { useMemo } from "react";
import { createUseStyles } from "$utils/createUseStyles";
import Badge from "$components/Badge";

type Props = {
  availableQty: number;
  qty: number;
};
function EntrepotQtyBadge({ availableQty, qty }: Props) {
  const classes = useStyles();
  const badgeStockColor = useMemo(() => {
    if (availableQty <= 0) return "red";
    if (availableQty < qty) return "orange";
    return "green";
  }, [availableQty, qty]);

  return (
    <Badge color={badgeStockColor} className={classes.stockQtyBadge}>
      {availableQty}
    </Badge>
  );
}

export default EntrepotQtyBadge;

const useStyles = createUseStyles(() => ({
  stockQtyBadge: {
    borderRadius: "12px !important",
    padding: "2px 10px !important",
  },
}));
